import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import {SET_CURRENT_WORKSPACE} from '@/store/app/mutationTypes';

export default class CurrentWorkspaceHelper {

	public static selectCurrentWorkspace(data: WorkspaceViewModel[], commit: any) {
		const lastStoredWorkspaceId = localStorage.getItem('CurrentWorkspace');
		if (lastStoredWorkspaceId == null || !data.some(workspace => workspace.id === lastStoredWorkspaceId)) {
			commit(SET_CURRENT_WORKSPACE, data[0]);
		} else {
			this.setToPreviousWorkspace(data, lastStoredWorkspaceId, commit);
		}
	}

	public static setToPreviousWorkspace(data: WorkspaceViewModel[], lastStoredWorkspaceId: string, commit: any) {
		data.forEach(workspace => {
			if (workspace.id === lastStoredWorkspaceId) {
				commit(SET_CURRENT_WORKSPACE, workspace);
			}
		});
	}

	public static storeCurrentWorkspace(workspaceId: string) {
		localStorage.setItem('CurrentWorkspace', workspaceId);
	}
}
